import React from 'react';
import {
  Box,
  Typography,
  Divider,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { PaymentData } from '../types/payment.types';

interface OrderSummaryProps {
  paymentData: PaymentData;
  onNext: () => void;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ paymentData, onNext }) => {
  const formatCurrency = (amount: number, currency: string) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    }).format(amount);
  };

  const calculateTax = (amount: number) => amount * 0.1; // 10% tax
  const calculateTotal = (amount: number) => amount + calculateTax(amount);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Détails de la transaction
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Veuillez vérifier les détails de la transaction avant de procéder au paiement
      </Typography>

      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Détails de la transaction
          </Typography>
          
          <List disablePadding>
            <ListItem disablePadding>
              <ListItemText
                primary="ID de la transaction"
                secondary={paymentData.orderId}
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemText
                primary="Description"
                secondary={paymentData.description}
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemText
                primary="Email du client"
                secondary={paymentData.customerEmail}
              />
            </ListItem>
            {paymentData.customerPhone && (
              <ListItem disablePadding>
                <ListItemText
                  primary="Numéro de téléphone"
                  secondary={paymentData.customerPhone}
                />
              </ListItem>
            )}
          </List>
        </CardContent>
      </Card>

      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Détails du prix
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body1">
              Sous-total
            </Typography>
            <Typography variant="body1">
              {formatCurrency(paymentData.amount, paymentData.currency)}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body1">
              Frais (10%)
            </Typography>
            <Typography variant="body1">
              {formatCurrency(calculateTax(paymentData.amount), paymentData.currency)}
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6" fontWeight="bold">
              Total à payer
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="primary">
              {formatCurrency(calculateTotal(paymentData.amount), paymentData.currency)}
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" align="center">
            En procédant, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité
          </Typography>
        </CardContent>
      </Card>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          variant="contained"
          size="large"
          onClick={onNext}
          sx={{ minWidth: 200 }}
        >
          Proceed to Payment
        </Button>
      </Box>
    </Box>
  );
};

export default OrderSummary; 